export default "__VITE_ASSET__Bpo5bNCC__"